/**
 * ViewItem.jsx
 *
 * Renders a single view type with an add button.
 * Used in the AvailableViews list.
 */

import { memo } from "react";
import PropTypes from "prop-types";
import AddIcon from "@mui/icons-material/Add";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

/**
 * Displays a view name with an associated "add" button.
 *
 * @component
 * @param {Object} props
 * @param {string} props.name - Display name of the view type.
 * @param {Function} props.onAdd - Callback fired when the "add" button is clicked.
 */
const ViewItem = ({ name, onAdd }) => (
  <ListItem
    secondaryAction={
      <IconButton edge="end" aria-label="add" onClick={onAdd}>
        <AddIcon />
      </IconButton>
    }
  >
    <ListItemText primary={name} />
  </ListItem>
);

ViewItem.propTypes = {
  name: PropTypes.string.isRequired,
  onAdd: PropTypes.func.isRequired,
};

ViewItem.displayName = "ViewItem";

export default memo(ViewItem);
